// formSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProgressState {
  progressCheck: boolean;
}

const initialState: ProgressState = {
  progressCheck: false,
};

export const progressCheck = createSlice({
  name: 'progress',
  initialState,
  reducers: {
    setCertificationDisabled: (state, action: PayloadAction<boolean>) => {
      state.progressCheck = action.payload;
    },
  },
});

export const { setCertificationDisabled } = progressCheck.actions;

export default progressCheck.reducer;
